import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as codeApi from '../../lib/api/purchaseMaintenanceCode';

// 1. 액션 타입 정의
const [
  LIST_PURCHASE_MAINTENANCE, 
  LIST_PURCHASE_MAINTENANCE_SUCCESS, 
  LIST_PURCHASE_MAINTENANCE_FAILURE
] = createRequestActionTypes('purchaseMaintenance/LIST_PURCHASE_MAINTENANCE');

const [
  UPDATE_PURCHASE_MAINTENANCE, 
  UPDATE_PURCHASE_MAINTENANCE_SUCCESS, 
  UPDATE_PURCHASE_MAINTENANCE_FAILURE
] = createRequestActionTypes('purchaseMaintenance/UPDATE_PURCHASE_MAINTENANCE');

// [추가] 일괄 발행 액션 타입
const [
  UPDATE_BULK_PURCHASE, 
  UPDATE_BULK_PURCHASE_SUCCESS, 
  UPDATE_BULK_PURCHASE_FAILURE
] = createRequestActionTypes('purchaseMaintenance/UPDATE_BULK_PURCHASE');

// 2. 액션 생성 함수
export const listPurchaseMaintenance = createAction(LIST_PURCHASE_MAINTENANCE, (searchData) => searchData);
export const updatePurchaseMaintenance = createAction(UPDATE_PURCHASE_MAINTENANCE, (updateData) => updateData);
// [추가] 일괄 발행 액션 생성 함수
export const updateBulkPurchase = createAction(UPDATE_BULK_PURCHASE, (bulkData) => bulkData);

// 3. 사가(Saga) 구성
const listPurchaseMaintenanceSaga = createRequestSaga(LIST_PURCHASE_MAINTENANCE, codeApi.getpurchaseMaintenanceList);

function* updatePurchaseMaintenanceSaga(action) {
  try {
    const response = yield call(codeApi.updatePurchaseMaintenance, action.payload);
    yield put({
      type: UPDATE_PURCHASE_MAINTENANCE_SUCCESS,
      payload: response.data,
    });
    // 성공 후 재조회
      const searchParams = {
      ...action.payload.searchParams,
      payYn: action.payload.searchParams?.payYn || 'N' // 값이 없으면 기본 'N' 처리
  };
    yield put(listPurchaseMaintenance(searchParams));
  } catch (e) {
    yield put({
      type: UPDATE_PURCHASE_MAINTENANCE_FAILURE,
      payload: e,
      error: true,
    });
  }
}

// [추가] 일괄 발행 사가
function* updateBulkPurchaseSaga(action) {
  try {
    // API 호출 (서버에서 배열 형태로 데이터를 받아 처리한다고 가정)
    const response = yield call(codeApi.updatePurchaseMaintenanceBulk, action.payload);
    
    yield put({
      type: UPDATE_BULK_PURCHASE_SUCCESS,
      payload: response.data,
    });

    // 일괄 발행 성공 후 리스트 재조회 (데이터 최신화 및 체크박스 상태 초기화 유도)
    const searchParams = action.payload.searchParams || {};
    yield put(listPurchaseMaintenance(searchParams));

  } catch (e) {
    yield put({
      type: UPDATE_BULK_PURCHASE_FAILURE,
      payload: e,
      error: true,
    });
  }
}

export function* purchaseMaintenanceSaga() {
  yield takeLatest(LIST_PURCHASE_MAINTENANCE, listPurchaseMaintenanceSaga);
  yield takeLatest(UPDATE_PURCHASE_MAINTENANCE, updatePurchaseMaintenanceSaga);
  yield takeLatest(UPDATE_BULK_PURCHASE, updateBulkPurchaseSaga); // 추가
}

// 4. 초기 상태 및 리듀서
const initialState = {
  list: null,
  saveResult: null,
  listError: null,
  saveError: null,
};

const purchaseMaintenance = handleActions(
  {
    [LIST_PURCHASE_MAINTENANCE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      list: data.list.map((value) => ({
        id: value.waitUuid,
        prjUuid: value.prjUuid,
        reqCompDt: value.reqCompDt,
        partnerNm: value.partnerNm,
        partnerUuid: value.partnerUuid,
        content: value.content,
        amount: value.amount,
        payYn: value.payYn,
        payPlanDt: value.payPlanDt,
        cstNm: value.cstNm,
        invUuid : value.invUuid,
        dptUuid: value.dptUuid,
        usrNm: value.usrNm,
      })),
      listError: null,
    }),
    [LIST_PURCHASE_MAINTENANCE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      listError: error,
    }),
    [UPDATE_PURCHASE_MAINTENANCE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      // 개별 업데이트 시 해당 항목만 상태 변경 (재조회 전 즉시 반영용)
      list: state.list.map((item) =>
        item.id === data.waitUuid ? { ...item, inspectCon: 'Y' } : item
      ),
      saveError: null,
    }),
    // [추가] 일괄 발행 성공/실패 처리
    [UPDATE_BULK_PURCHASE_SUCCESS]: (state) => ({
      ...state,
      saveError: null,
    }),
    [UPDATE_BULK_PURCHASE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      saveError: error,
    }),
  },
  initialState,
);

export default purchaseMaintenance;
